var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.head.value))]),_c('br'),_c('isc-single-select',{attrs:{"title":("Select " + (_vm.head.value)),"label":"title","options":_vm.filterOptions},on:{"applied":_vm.addFilter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }